var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockCounterClockwise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5v2.717l2.258 1.354a.5.5 0 01-.515.858l-2.5-1.5A.5.5 0 017.5 8V5a.5.5 0 111 0zM8 2a5.965 5.965 0 00-4.245 1.76A25.8 25.8 0 002.5 5.124V4a.5.5 0 10-1 0v2.5A.5.5 0 002 7h2.5a.5.5 0 100-1H3.062c.447-.526.892-1.022 1.4-1.536a5 5 0 11.104 7.172.5.5 0 10-.688.728A6 6 0 108 2z",
    fill: "currentColor"
  })));
}
export default SvgClockCounterClockwise;